import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import { ValidateEmail } from './components/ValidateEmail'
import { ResetPassword } from './components/ResetPassword'
import { IntlProvider, useIntl } from 'react-intl'
import enMessages from '../../../_metronic/i18n/messages/en.json'
import trMessages from '../../../_metronic/i18n/messages/tr.json'
import { useState } from 'react'
//src/_metronic/i18n/messages/tr.json
const allMessages = {
  en: enMessages,
  tr: trMessages,
}



function AuthPage () {
  const intl = useIntl()
const [locale, setLocale] = useState('tr'); // Default language
  return(
    <IntlProvider locale={locale} messages={allMessages[locale]}>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path='login' element={<Login setLocale={setLocale} />} />
          <Route path='registration' element={<Registration setLocale={setLocale} />} />
          <Route path='forgot-password' element={<ForgotPassword />} />
          <Route path='validate-email' element={<ValidateEmail />} />
          <Route path='reset-password' element={<ResetPassword />} />
          <Route index element={<Login setLocale={setLocale} />} />
        </Route>
      </Routes>
    </IntlProvider>
  );
}

export {AuthPage}
